import { SocialShare } from './social-share';

export class PinterestShare extends SocialShare {
  protected generateShareUrl(): string {
    return `http://pinterest.com/pin/create/bookmarklet/?media=${encodeURIComponent(this.url)}&url=${
      window.location.hostname
    }&is_video=0&description=`;
  }
}
